import * as React from "react";
import { useAppDispatch, useAppSelector } from "../../store/hooks";
import { ViewModal } from "../../components/modals/viewModal";
import { setDeploymentViewObject } from "../../store/workloadSlice";
import { parseLink } from "../../utils/linkParser/linkParser";

export const WorkloadViewModal: React.FC = () => {
  const dispatch = useAppDispatch();
  const workloadLink = useAppSelector((state) => state.workload.workloadLink);
  const data = useAppSelector((state) => state.workload.deploymentViewObject);

  function getViewModalTitle(): string {
    const { name, gvc } = parseLink(workloadLink);
    let value = `Deployments (${name})`;
    // if (viewInfo) {
    //   if (viewInfo.deployment) {
    //     value = `Deployment ${viewInfo.deployment}`;
    //   }
    //   if (viewInfo.version !== undefined) {
    //     value = `${viewInfo.deployment} ver. ${viewInfo.version}`;
    //   }
    // }
    return value;
  }

  function getViewModalFilename(): string {
    // let value = `org-${org}-gvc-${workload.gvc}-workload-${workload.name}-deployments`;
    // if (viewInfo) {
    //   if (viewInfo.deployment) {
    //     value += `-${viewInfo.deployment}`;
    //   }
    //   if (viewInfo.version !== undefined) {
    //     value += `-version-${viewInfo.version}`;
    //   }
    //   if (viewInfo.container) {
    //     value += `-container-${viewInfo.container}`;
    //   }
    // }
    // return value;
    return "test";
  }

  if (!data) {
    return null;
  }

  return (
    <ViewModal
      kind={"deployment"}
      object={data}
      onClose={() => dispatch(setDeploymentViewObject({ workloadLink: "", data: null }))}
      title={getViewModalTitle()}
      visible={!!data}
      filename={getViewModalFilename()}
      noSlim
    />
  );
};
